import { render, staticRenderFns } from "./SupplyDocumentTable.vue?vue&type=template&id=86fcaa62&"
import script from "./SupplyDocumentTable.vue?vue&type=script&lang=js&"
export * from "./SupplyDocumentTable.vue?vue&type=script&lang=js&"
import style0 from "./SupplyDocumentTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports